var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      {
        staticClass: "row advisor-search-page-name floating-label",
        class: { "has-focus is-floating": _vm.focused },
        attrs: {
          id: "advisor-search-by-name",
          role: "tabpanel",
          "aria-labelledby": "advisor-search-page-tab_by_name",
          tabindex: "0"
        }
      },
      [
        _c("span", { staticClass: "pill large" }, [
          _c(
            "label",
            {
              staticClass: "search-name-label",
              attrs: { for: "advisorName-id-field" }
            },
            [_vm._v(_vm._s(_vm.placeholder))]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.name,
                expression: "name"
              }
            ],
            attrs: {
              id: "advisorName-id-field",
              type: "text",
              "aria-label": "Search by name",
              "aria-describedby": _vm.showError ? "error-search-by-name" : ""
            },
            domProps: { value: _vm.name },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.setName($event)
              },
              focus: function($event) {
                _vm.focused = true
              },
              blur: _vm.handleBlur,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.name = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "advisor-search-container__filters-search ",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.setName($event)
                }
              }
            },
            [
              _c("img", {
                attrs: {
                  src: "/Static/assets/images/search_icon_red.svg",
                  alt: "search"
                }
              })
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _vm.showError
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "p",
              {
                staticClass: "text-danger",
                attrs: { id: "error-search-by-name" }
              },
              [_vm._v(_vm._s(_vm.text("advisorSearchByNameError")))]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }